import { isEmpty } from '@jjj/components';
import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';
import { withTZ, withUTC } from '../../../../../../helpers/dateTime';
import { keyBy } from '../../../../../../helpers/core';
import { t } from '../../../../../../i18n';

const initState = {
  editForm: null,
  loading: false,
};

function validate(attr, value, valueToCompare) {
  let error = '';

  if (attr === 'started_at') {
    if (isEmpty(value)) {
      error = t('dash.validation.choose_a_field', { fieldName: t('dash.jobs.bookings.undoNCNS.started_at_label') });
    }
  }

  if (attr === 'finished_at') {
    if (isEmpty(value)) {
      error = t('dash.validation.choose_a_field', { fieldName: t('dash.jobs.bookings.undoNCNS.finished_at_label') });
    }
  }

  if (attr === 'finished_at') {
    if (valueToCompare && value && withTZ(valueToCompare).isSameOrAfter(withTZ(value), 'minutes')) {
      error = t('dash.validation.mast_be_after_error', {
        firstFieldName: t('dash.jobs.bookings.undoNCNS.finished_at_label'),
        secondFieldName: t('dash.jobs.bookings.undoNCNS.started_at_label'),
      });
    }
  }

  return error;
}

function onLoadForm(state, { payload }) {
  const { bookingType } = payload;
  const editFormObject = {
    started_at: null,
    ...(bookingType === 'past' && { finished_at: null }),
  };

  const propsArray = Object.keys(editFormObject);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: editFormObject[prop],
      error: validate(prop, editFormObject[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    editForm: { ...editForm },
  };
}

function onClearStore() {
  return { ...initState };
}

function onSendRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onSendSuccess(state) {
  return {
    ...state,
    editForm: null,
    loading: false,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value, silence } = payload;
  const { editForm } = state;
  let valueToCompare = null;

  if (attr === 'finished_at') {
    valueToCompare = editForm.started_at && editForm.started_at.value ? withUTC(editForm.started_at.value) : null;
  }

  if (attr === 'started_at') {
    valueToCompare = editForm.finished_at && editForm.finished_at.value ? withUTC(editForm.finished_at.value) : null;
  }

  editForm[attr] = {
    value,
    error: validate(attr, value, valueToCompare),
    name: attr,
    touched: !silence,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

export default createReducer(initState, {
  [actions.LOAD_FORM]: onLoadForm,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.SEND_REQUEST]: onSendRequest,
  [actions.SEND_SUCCESS]: onSendSuccess,
  [actions.TOUCH]: onTouch,
});
